

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const MICROSOFTUSERSSYNC= createAsyncThunk(
  "MicrosoftUsersync/MicrosoftUsersync",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const MicrosoftUsersyncSlice = createSlice({
  name: "MicrosoftUsersyncSlice",
  initialState: {
    MicrosoftUsersync: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfMicrosoftUsersync: (state) => {
        state.MicrosoftUsersync.loading = false
        state.MicrosoftUsersync.error = false
        state.MicrosoftUsersync.data = []
        state.MicrosoftUsersync.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(MICROSOFTUSERSSYNC.fulfilled, (state, action) => {
      state.MicrosoftUsersync = {
        ...state.MicrosoftUsersync,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MICROSOFTUSERSSYNC.pending, (state, action) => {
      state.MicrosoftUsersync = {
        ...state.MicrosoftUsersync,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(MICROSOFTUSERSSYNC.rejected, (state, action) => {
      state.MicrosoftUsersync = {
        ...state.MicrosoftUsersync,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const MicrosoftUsersyncAction = {
    MICROSOFTUSERSSYNC,
};

export { MicrosoftUsersyncAction };
export default MicrosoftUsersyncSlice.reducer;
export const {setInitialStateOfMicrosoftUsersync} = MicrosoftUsersyncSlice.actions
